import { render, staticRenderFns } from "./form-row-edit-addresses-new.vue?vue&type=template&id=0f78a98d&scoped=true&"
import script from "./form-row-edit-addresses-new.vue?vue&type=script&lang=js&"
export * from "./form-row-edit-addresses-new.vue?vue&type=script&lang=js&"
import style0 from "./form-row-edit-addresses-new.vue?vue&type=style&index=0&id=0f78a98d&lang=css&"
import style1 from "./form-row-edit-addresses-new.vue?vue&type=style&index=1&id=0f78a98d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78a98d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f78a98d')) {
      api.createRecord('0f78a98d', component.options)
    } else {
      api.reload('0f78a98d', component.options)
    }
    module.hot.accept("./form-row-edit-addresses-new.vue?vue&type=template&id=0f78a98d&scoped=true&", function () {
      api.rerender('0f78a98d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-edit-addresses-new.vue"
export default component.exports